import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import FormProvider, { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import { useNavigate, useLocation } from 'react-router';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { Controller, useForm } from 'react-hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import { endpoints } from 'src/utils/axios';
import { DatePicker } from '@mui/x-date-pickers';
import { postRequest } from 'src/services';
import { currencyOptions } from '../finance-statement/currencies-list';
import { formatDate } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
import { useTheme } from '@emotion/react';

const BankInfoInstantCreate = ({open, onClose, reloadBankInfo}) => {

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const theme = useTheme()
  
  // Extract profile data for create action
  const myProfile = state;
  
  // Extract existing data for edit action
  const data = state?.data || {}; 
  const ID = data?.id; 
  
  console.log("🚀 ~ state, prof,id:", { state, myProfile, ID });

  const defaultValues = {

  };


  const NewUserSchema = Yup.object().shape({
    /* full_name: Yup.string().required('Full name is required'),
    address: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    zip: Yup.string().required('ZIP code is required'),
    phone_number: Yup.string()
      .matches(/^\d+$/, 'Phone number must be numeric')
      .required('Phone number is required'),
    email_address: Yup.string()
      .email('Invalid email address')
      .required('Email address is required'),
    company_name: Yup.string().required('Company name is required'),
    company_address: Yup.string().required('Company address is required'),
    tax_id: Yup.string().required('Tax ID is required'),
    bank_name: Yup.string().required('Bank name is required'),
    bank_address: Yup.string().required('Bank address is required'),
    bank_city: Yup.string().required('Bank city is required'),
    bank_state: Yup.string().required('Bank state is required'),
    bank_zip: Yup.string().required('Bank ZIP code is required'),
    bank_phone_number: Yup.string()
      .matches(/^\d+$/, 'Bank phone number must be numeric')
      .required('Bank phone number is required'),
    currency: Yup.string().required('Currency is required'),
    opening_balance: Yup.number()
      .min(0, 'Opening balance cannot be negative')
      .required('Opening balance is required'),
    bank_account_type: Yup.string().required('Bank account type is required'),
    account_number: Yup.string()
      .matches(/^\d+$/, 'Account number must be numeric')
      .required('Account number is required'),
    routing_number: Yup.string()
      .matches(/^\d+$/, 'Routing number must be numeric')
      .required('Routing number is required'),
    purpose_of_account: Yup.string().required('Purpose of account is required'),
    opening_date: Yup.date()
      .max(new Date(), 'Opening date cannot be in the future')
      .required('Opening date is required'),
    signature: Yup.string().required('Signature is required'),
    balance: Yup.number()
      .min(0, 'Balance cannot be negative')
      .required('Balance is required'),  */
  });

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    control,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {

    try {
      const formData = new FormData();
      formData.append('full_name', data.full_name);
      formData.append('bank_name', data.bank_name || '');
      formData.append('opening_balance', data.opening_balance || '');
      formData.append('opening_date', formatDate(data.opening_date) || '');

      const result = await postRequest(
        ID ? `${endpoints.accounting.bank_information.post_list}/${ID}?_method=PUT`
          : endpoints.accounting.bank_information.post_list,
        formData,
        true
      );

      //console.log(data)

      reloadBankInfo()
      reset();
      onClose();
    } catch (err) {
      console.error('Error in catch:', err);
    }
  });


  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      fullWidth
      maxWidth="md"
      sx={{
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      }}
      transitionDuration={{
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <span
            className="cardColor"
            style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}
          >
            &nbsp;&nbsp; BANK & CREDIT CARD INFORMATION &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={onClose}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            borderRadius: '1px',
          }}
        >
          <Box
            mt={2}
            rowGap={2}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <RHFTextField name="full_name" label="Full Name" />
            <RHFTextField name="bank_name" label="Bank Name" />
            <RHFTextField name="opening_balance" label="Opening Balance" type="number" />
            <Controller
              name="opening_date"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <DatePicker
                  {...field}
                  label="Date of Opening"
                  value={field.value ? new Date(field.value) : null} // Ensures a valid date
                  onChange={(newValue) => field.onChange(newValue)}
                  maxDate={new Date()} // Disables future dates
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!error,
                      helperText: error?.message,
                    },
                  }}
                />
              )}
            />
          </Box>

        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={isSubmitting}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default BankInfoInstantCreate;
